import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BackupIncomplete, InstallNotConnect, SalesNotInService } from 'src/app/model/installations/installations.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-home-warning',
  templateUrl: './home-warning.component.html',
  styleUrls: ['./home-warning.component.scss']
})
export class HomeWarningComponent implements OnInit {

  constructor(private service : InstallationsService,private utilsService: UtilsService, private router : Router) { }

  public installs! :InstallNotConnect[];
  public backups! :BackupIncomplete[];
  public installsNotInService! :SalesNotInService[];

  ngOnInit(): void {


    this.service.getInstallationsNotConnectedList()
              .subscribe( 
                (installs) => {
                  this.installs = installs
                  // console.log(this.installs);
                });

    this.service.getBackupsIncompleteList()
              .subscribe( 
                (installs) => {
                  this.backups = installs
                  // console.log(this.installs);
                });
    this.service.getSalesNotInServiceList()
              .subscribe( 
                (installs) => {
                  this.installsNotInService = installs
                  // console.log(this.installs);
                });

    
  }

  /** Format pretty dates */
  getNiceDate(toFormat : string): string{
    return this.utilsService.getNiceLocaleDate(toFormat);
  }

  /**
   * Go to installation page
   * @param id : install.ID_INSTALLATION
   */

  getInstallPage(id : number) {
    this.router.navigate(['installation', id]);
  }

}
